// src/pages/TrialBalance/components/exportTrialBalanceCsv.js

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.dataSource  - rows array (same shape as TrialBalanceTable uses)
 * @param {string}  params.currency    - e.g. "₹"
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportTrialBalanceCsv = ({
  dataSource,
  currency = "",
  title = "Trial Balance",
  filename = "trial_balance",
}) => {
  const fmtVal = (val) =>
    !val && val !== 0 ? "------" : `${currency} ${fmt(val)}`.trim();

  const totalDebit  = dataSource.reduce((s, r) => s + (r.debit  || 0), 0);
  const totalCredit = dataSource.reduce((s, r) => s + (r.credit || 0), 0);

  const headers = ["Particulars Account Head", "Debit", "Credit"].map(escape);

  const dataRows = dataSource.map((r) => [
    r.label,
    fmtVal(r.debit),
    fmtVal(r.credit),
  ].map(escape));

  const totalRow = [
    "Grand Total",
    `${currency} ${fmt(totalDebit)}`.trim(),
    `${currency} ${fmt(totalCredit)}`.trim(),
  ].map(escape);

  const rows = [
    [title],
    [],
    headers,
    ...dataRows,
    [],           // blank spacer before totals
    totalRow,
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};